import { GenIcon } from 'react-icons';
export const MdCurrencyFlagNzd = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 90 90',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_nzd)' },
            child: [
                // Dark blue circle background
                {
                    tag: 'circle',
                    attr: {
                        cx: '45',
                        cy: '45',
                        r: '45',
                        fill: '#000066',
                    },
                    child: [],
                },
                // Star 1 (top right) - white outline
                {
                    tag: 'path',
                    attr: {
                        d: 'M67.422 36.949l-2.634-1.947l-2.731 1.806l1.028-3.12l-2.553-2.053l3.269 0.019l1.153-3.075l0.994 3.131l3.264 0.153l-2.655 1.916L67.422 36.949z',
                        fill: '#F3F4F5',
                    },
                    child: [],
                },
                // Star 1 - red center
                {
                    tag: 'path',
                    attr: {
                        d: 'M66.365 35.373l-1.558-1.127l-1.593 1.077l0.585-1.838l-1.512-1.19l1.921-0.009l0.658-1.813l0.601 1.833l1.918 0.069l-1.547 1.142L66.365 35.373z',
                        fill: '#FF0000',
                    },
                    child: [],
                },
                // Star 2 (middle) - white outline
                {
                    tag: 'path',
                    attr: {
                        d: 'M57.313 53.731l-2.634-1.947l-2.731 1.806l1.028-3.12l-2.553-2.053l3.269 0.019l1.153-3.075l0.994 3.131l3.264 0.152l-2.655 1.916L57.313 53.731z',
                        fill: '#F3F4F5',
                    },
                    child: [],
                },
                // Star 2 - red center
                {
                    tag: 'path',
                    attr: {
                        d: 'M56.256 52.154l-1.558-1.127l-1.593 1.077l0.585-1.838l-1.512-1.19l1.921-0.009l0.658-1.813l0.601 1.833l1.918 0.069l-1.547 1.142L56.256 52.154z',
                        fill: '#FF0000',
                    },
                    child: [],
                },
                // Star 3 (right) - white outline
                {
                    tag: 'path',
                    attr: {
                        d: 'M78.001 52.077l-2.634-1.947l-2.731 1.806l1.028-3.12l-2.553-2.053l3.269 0.019l1.153-3.075l0.994 3.131l3.264 0.152l-2.654 1.917L78.001 52.077z',
                        fill: '#F3F4F5',
                    },
                    child: [],
                },
                // Star 3 - red center
                {
                    tag: 'path',
                    attr: {
                        d: 'M76.945 50.501l-1.558-1.127l-1.593 1.077l0.585-1.838l-1.512-1.19l1.921-0.009l0.658-1.813l0.601 1.833l1.918 0.069l-1.547 1.142L76.945 50.501z',
                        fill: '#FF0000',
                    },
                    child: [],
                },
                // Star 4 (bottom) - white outline
                {
                    tag: 'path',
                    attr: {
                        d: 'M67.187 75.949l-2.634-1.947l-2.731 1.806l1.028-3.12l-2.553-2.053l3.269 0.019l1.153-3.075l0.994 3.131l3.264 0.153l-2.655 1.916L67.187 75.949z',
                        fill: '#F3F4F5',
                    },
                    child: [],
                },
                // Star 4 - red center
                {
                    tag: 'path',
                    attr: {
                        d: 'M66.13 74.373l-1.558-1.127l-1.593 1.077l0.585-1.838l-1.512-1.19l1.921-0.009l0.658-1.813l0.601 1.833l1.918 0.069l-1.547 1.142L66.13 74.373z',
                        fill: '#FF0000',
                    },
                    child: [],
                },
                // Union Jack - white background
                {
                    tag: 'path',
                    attr: {
                        d: 'M27.452 24.53V12.82h-8.276v11.709l-8.656-8.436c-1.438 1.713-2.754 3.533-3.927 5.449L14.62 29.2H2.86c-0.984 2.622-1.724 5.362-2.206 8.19h13.605L0.397 50.9c0.127 0.966 0.277 1.925 0.464 2.87h5.396l12.92-12.327V53.77h8.276V41.443l12.921 12.328h8.804L32.371 37.39h16.805V29.2H32.01l17.168-16.38v0l-9.731 0.019L27.452 24.53z',
                        fill: '#F3F4F5',
                    },
                    child: [],
                },
                // Union Jack - red diagonal
                {
                    tag: 'path',
                    attr: {
                        d: 'M45.952 12.82L3.944 53.769l-3.269 0.002L42.859 12.82H45.952L45.952 12.82z',
                        fill: '#FF0000',
                    },
                    child: [],
                },
                // Union Jack - red cross vertical/horizontal
                {
                    tag: 'path',
                    attr: {
                        d: 'M25.643 12.82h-4.655v18.428H2.148c-0.429 1.339-0.794 2.705-1.098 4.095h19.938V53.77h4.655V35.343h23.533v-4.095H25.643V12.82z',
                        fill: '#FF0000',
                    },
                    child: [],
                },
                // Union Jack - red diagonal 2
                {
                    tag: 'path',
                    attr: {
                        d: 'M7.756 19.74l35.11 34.029h3.094l0-0.001L9.11 17.859C8.644 18.475 8.191 19.101 7.756 19.74z',
                        fill: '#FF0000',
                    },
                    child: [],
                },
                // White border stroke
                {
                    tag: 'circle',
                    attr: {
                        cx: '45',
                        cy: '45',
                        r: '44',
                        stroke: 'white',
                        strokeWidth: '1',
                        fill: 'none',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_nzd' },
                    child: [
                        {
                            tag: 'circle',
                            attr: {
                                cx: '45',
                                cy: '45',
                                r: '45',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
